import React from "react";

export const Logo = ({ className = "", size = "md" }) => {
  const sizes = {
    sm: { text: "text-xl", icon: "h-6 w-6", gap: "gap-1" },
    md: { text: "text-2xl", icon: "h-7 w-7", gap: "gap-1" },
    lg: { text: "text-4xl", icon: "h-10 w-10", gap: "gap-1.5" },
  };
  const s = sizes[size];
  return (
    <div className={`flex items-center ${s.gap} ${className}`} data-testid="execora-logo">
      <img
        src="/execora-icon.svg"
        alt="Execora"
        className={`${s.icon} shrink-0`}
        loading="eager"
      />
      <span className={`font-logo ${s.text} text-slate-900 leading-none tracking-tight`}>
        execora
      </span>
    </div>
  );
};

export default Logo;
